<template>
    <div id="CancelBooking">
        <div class="content-container" v-if="!loading">
            <div class="cancel-container" v-if="!cancelSuccess">
                <h1 class="title brand-text">Why are you cancelling?</h1>
                <p class="sub-title brand-text">Your feedback helps us improve the My Bupa app.</p>
                <p class="description mb-5 brand-text"><b>Select from the options below</b></p>

                <b-button v-for="option in buttonSelectionOptions" @click="selectOption(option)"
                    :variant="option === selectedOption ? 'active-outline' : 'gray-outline'" size="lg"
                    class="d-block mb-4" squared :class="[option === selectedOption ? 'selected' : '', showErrorMessage ? 'error-button' : '' ]">{{ option.text
                    }}</b-button>
                <div class="error-container" v-if="showErrorMessage">
                    <i class="fa-solid fa-triangle-exclamation mr-3"></i> Please select an option from the list above
                </div>
                <div class="button-row">
                    <b-button variant="transparent" class="mr-5 mb-3 px-5 py-4" size="lg" @click="$router.push('/gp')"
                        squared><i class="fa-solid fa-chevron-left mr-3"></i>Back</b-button>
                    <b-button variant="cta" class="mr-5 mb-3 px-5 py-4" size="lg" squared
                        @click="cancelBooking()">Cancel Appointment<i class="fa-solid fa-chevron-right ml-3"></i></b-button>
                </div>
            </div>
            <div class="cancel-container" v-else>
                <h1 class="title brand-text mb-5">Your appointment has been cancelled</h1>
                <p class="sub-title brand-text mb-3">Thank you for your feedback, this will help us to improve the digital appointment experience.</p>
                <p class="description mb-5 brand-text">If you need a new appointment, you can book one whenever you need to.</p>
                <div class="button-row pt-5">
                    <b-button variant="transparent" class="mr-5 mb-3 px-5 py-4" size="lg" @click="$router.push('/gp')"
                        squared><i class="fa-solid fa-chevron-left mr-3"></i>Home</b-button>
                    <b-button variant="cta" class="mr-5 mb-3 px-5 py-4" size="lg" squared
                        @click="$router.push('/matchtech')">Book a new appointment<i class="fa-solid fa-chevron-right ml-3"></i></b-button>
                </div>
            </div>
        </div>
        <div class="d-flex flex-row  justify-content-center pt-5" style="height: 80vh" v-else>
            <b-spinner class="brand-primary mt-5" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import config from "../config/constants";
import ErrorModal from "@/components/GP/ErrorModal.vue";

export default {
    name: "CancelBooking",
    components: {
    },
    data() {
        return {
            buttonSelectionOptions: [
                { text: "I no longer need this appointment", value: "no longer needed", id: 0 },
                { text: "I can't make the appointment time", value: "cant make time", id: 1 },
                { text: "I need more urgent care", value: "need urgent care", id: 2 },
                { text: "I want to see a different clinician", value: "need different clinician", id: 3 },
                { text: "I booked more than one appointment", value: "booked more than one", id: 4 },
                { text: "Something else", value: "something else", id: 5 },
            ],
            selectedOption: null,
            bookingDetails: null,
            cancelSuccess: false,
            loading: true,
            showErrorMessage: false,

        };
    },
    mounted() {
        this.getBooking();
    },
    methods: {
        selectOption(opt) {
            this.selectedOption = opt;
            this.showErrorMessage = false;
        },
        async getBooking() {
            let params = {
                path: "api/u/gp/get-booking",
                booking_id: this.$route.params.id,
            }
            let res = await this.api(params)
            if (res.success === true) {
                this.bookingDetails = res.booking;
                this.loading = false;
            } else if (res.message.includes('Booking not found')) {
                let self = this;
                this.openErrorModal('Booking not found', "This booking was not found. It may have been cancelled.").then(() => {
                    self.$router.push('/gp')
                });
            } else {
                this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
            }
        },
        async cancelBooking() {
            if (this.selectedOption === null) {
                this.showErrorMessage = true;
            } else {
                this.loading = true;
                let self = this;
                this.bookingCancelLoading = true;
                const payload = {
                    user_id: this.$store.getters.user_id,
                    booking_id: this.$route.params.id
                };
                let res = await axios.post(
                    config.api_env + "/application/api/u/gp/cancel-booking",
                    payload,
                    config.options
                );
                if (res.data.success) {
                    this.cancelSuccess = true;
                    this.loading = false;
                    this.$tag.event('appointment_cancelled', {
                        "option_selected": self.selectedOption.value,
                        "clinician_type": self.bookingDetails.appt_type,
                        "care_pathway": self.bookingDetails.appt_reason,
                        "booking_ID": self.bookingDetails.id,
                        "U16_booking_flag": "N"
                    });
                } else if (res.data.start_sso_journey) {
                    this.openErrorModal('Your session has expired', "Please log in and try again", true);
                } else if (res.data.err && res.data.err.includes("3994")) {
                    this.openErrorModal('Your session has expired', "Please log in and try again", true);
                } else {
                    this.openErrorModal("Sorry, we've had a problem", "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm");
                }
            }
        },
        openErrorModal(title, error, redirect, goBack) {
            const content = this.$createElement(ErrorModal, { props: { title, error, redirect, goBack } })
            const skin = this.$store.getters.skin;
            let opts = {
                hideHeader: true,
                hideFooter: true,
                modalClass: "coach_modal theme-" + skin,
                size: "md",
                buttonSize: "sm",
                centered: true,
                contentClass: "coach_modal",
                id: 'error-modal'
            }
            return this.$bvModal.msgBoxOk(content, opts);
        },
    },
    computed: {

    },
};
</script>
<style lang="less">
#CancelBooking {
    background-color: #F4F5F8;
    font-family: "Montserrat", serif !important;

    .cancel-container {
        padding: 50px 0;

        .title {
            font-weight: 500;
            margin-bottom: 20px;
        }

        .sub-title {
            font-size: 1.6rem;
            margin-bottom: 30px;
        }

        .description {
            font-size: 1.6rem;
        }

        .selected {}
        .error-button{
            border-color: #D60023;
        }
    }

    .error-container {
        margin: 20px 0;
        font-family: "Montserrat", serif !important;
        font-weight: 500;
        font-size: 1.6rem;
        padding: 15px;
        border: 1.5px solid #DB3907;
        background-color: #FBEACF;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 12px;

        i {
            color: #DB3907;
            font-size: 2.2rem;
        }
    }
}
</style>
